<template>
  <div class="awards">
    <div class="content">
      <div class="brief">
        <p v-for="(paragraph,index) in paragraphs" :key="index">{{paragraph}}</p>
      </div>
      <div class="awards-container">
        <div :style="{backgroundImage:`url('${award.image}')`}" v-for="(award,index) in awards"
             :class="{'has-link':award.link}"
             :key="index">
          <div>
            <a :href="award.link" target="_blank">查看获奖名单 ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'StockTake',
    computed: {
      ...mapState({
        paragraphs: state => state.awardsDemo.paragraphs,
        awards: state => state.awardsDemo.awards,
      })
    }
  };
</script>

<style scoped lang="less">
  .awards {
    display: flex;
    height: 100%;
  }

  .content {
    display: flex;
    margin: 3vh 0;
  }

  .brief {
    display: flex;
    width: 40vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1.6;
    text-align: justify;
    font-size: 2.5vh;
    font-weight: 100;

    p {
      width: 25vh;

      &:last-of-type {
        margin-top: 1em;
      }
    }
  }

  .awards-container {
    display: flex;
    justify-content: space-between;
    height: 100%;

    > div {
      position: relative;
      width: 26vh;
      height: 100%;
      margin-left: 1vh;
      box-shadow: 0 0 0 1px #f0f0f0;
      background-color: #d8d8d8;
      background-size: cover;

      &:only-of-type {
        width: 50vh;
      }

      > div {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, .5);
        visibility: hidden;
        opacity: 0;
        transition: opacity .3s;

        a {
          text-decoration: none;
          margin-top: 25vh;
          padding-bottom: 1px;
          border-bottom: 1px solid #FF3C00;
          color: #FF3C00;
          font-size: 2.2vh;
          font-weight: bold;
        }
      }
    }

    .has-link {
      &:hover {
        > div {
          visibility: visible;
          opacity: 1;
        }
      }
    }
  }
</style>
